import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Popconfirm, Tooltip, message } from "antd";
import { ReactNode } from "react";
import { GoodsAndServicesItem, useDeleteGoodsAndServicesItem } from "./useGoodsAndServices";

export default function DeleteGoodsAndServicesItemAction({
  children,
  goodsAndServicesItem,
  onSucces,
}: {
  children: ReactNode;
  goodsAndServicesItem: GoodsAndServicesItem;
  onSucces?: () => void;
}) {
  const deleteGoodsAndServicesItem = useDeleteGoodsAndServicesItem();
  const translation = useTranslation();

  return (
    <Popconfirm
      title={`Delete good or service`}
      description={
        <>
          <p>You are about to delete a good or service.</p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={() =>
        deleteGoodsAndServicesItem
          .mutateAsync({ goodsAndServicesItemId: goodsAndServicesItem.id })
          .then((result) => {
            if (result.status === 200) {
              message.success(`Good or service has been deleted.`);
              onSucces && onSucces();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete good or service`}
      cancelText="Cancel"
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteGoodsAndServicesItem.isLoading }}
      disabled={!goodsAndServicesItem.deletable}
    >
      <Tooltip
        placement="bottom"
        title={
          !goodsAndServicesItem.deletable && (
            <span>This good or service can not be deleted as it is referenced in a facility.</span>
          )
        }
      >
        {children}
      </Tooltip>
    </Popconfirm>
  );
}
